import { Box } from "@mui/material"
import { useNavigate, useParams, useSearch } from "@tanstack/react-router"
import type { FC } from "react"

import AccountingComments from "@/screens/CompanySettings/Accounting/components/AccountingComments"
import {
  AccountingSubTab,
  AccountingSubTabs,
} from "@/screens/CompanySettings/Accounting/components/AccountsPayable/AccountingSubTabs"
import { AccountsPayableBalanceTabPanel } from "@/screens/CompanySettings/Accounting/components/AccountsPayable/AccountsPayableBalanceTabPanel"
import { PaymentTermsSummary } from "@/screens/CompanySettings/Accounting/components/PaymentTermsAndLimits/PaymentTermsSummary"
import PaymentSettingsContainer from "@/screens/CompanySettings/Accounting/containers/PaymentSettingsContainer"
import { PaymentTermsProvider } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"
import { useAccountsPayableBalancePermissions } from "@/screens/CompanySettings/Accounting/hooks/useAccountsPayableBalancePermissions"

const ROUTE = "/app/companies/$companyId/edit/_layout/accounting"

const AccountingContainer: FC = () => {
  const { companyId } = useParams({ from: "/app/companies/$companyId/edit" })
  const { subTab } = useSearch({ from: ROUTE })
  const navigate = useNavigate({ from: ROUTE })

  const { canViewAccountsPayableBalance } = useAccountsPayableBalancePermissions({ companyId })

  const handleSubTabChange = (newSubTab: AccountingSubTab) => {
    navigate({ search: (prev) => ({ ...prev, subTab: newSubTab }) })
  }

  const isBalanceTabVisible =
    subTab === AccountingSubTab.AccountsPayableBalanceAndTransactions && canViewAccountsPayableBalance

  return (
    <Box className='flex h-full flex-col space-y-4'>
      <PaymentTermsProvider>
        <PaymentTermsSummary companyId={companyId} />
        <AccountingSubTabs
          value={subTab}
          onChange={handleSubTabChange}
          canViewAccountsPayableBalance={canViewAccountsPayableBalance}
        />
        {isBalanceTabVisible ? (
          <AccountsPayableBalanceTabPanel />
        ) : (
          <>
            <PaymentSettingsContainer companyId={companyId} />
            <AccountingComments companyId={companyId} />
          </>
        )}
      </PaymentTermsProvider>
    </Box>
  )
}

export default AccountingContainer
